(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content-section"] && !Shopify.designMode) return;
  try {
    
  class TabbedContent extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.tab-content-container');
      this.tabButtons = this.querySelectorAll('.tab-button');
      this.tabPanes = this.querySelectorAll('.tab-pane');
      
      if (!this.container || !this.tabButtons.length || !this.tabPanes.length) {
        console.warn('TabbedContent: Missing required elements.');
        return;
      }

      this.initTabs();
    }

    initTabs() {
      this.tabButtons.forEach(button => {
        button.addEventListener('click', this.handleTabClick.bind(this));
      });

      const firstActivePane = this.querySelector('.tab-pane.active');
      if (firstActivePane) {
        this.triggerAnimations(firstActivePane);
      }
      
      // Set initial height on load
      requestAnimationFrame(() => {
        this.updateContainerHeight();
      });
      
      // Recalculate height on window resize
      window.addEventListener('resize', () => this.updateContainerHeight());
    }

    updateContainerHeight() {
      const activePane = this.querySelector('.tab-pane.active');
      if (!activePane) {
        this.container.style.minHeight = '0px';
        return;
      }
      
      const innerContent = activePane.querySelector('.tab-pane__inner');
      if(innerContent) {
        // Get the height of the inner white box
        const contentHeight = innerContent.offsetHeight;
        
        // Get the padding of the .tab-pane wrapper
        const paneStyles = window.getComputedStyle(activePane);
        const panePadding = parseFloat(paneStyles.paddingTop) + parseFloat(paneStyles.paddingBottom);
        
        // Total height is the box height + the pane's padding
        const totalHeight = contentHeight + panePadding;
        
        this.container.style.minHeight = `${totalHeight}px`;
      }
    }

    handleTabClick(event) {
      const clickedButton = event.currentTarget;
      const targetPaneId = clickedButton.dataset.tabTarget;
      const targetPane = this.querySelector(targetPaneId);

      if (!targetPane) {
        console.error('TabbedContent: No pane found with ID:', targetPaneId);
        return;
      }

      if (clickedButton.classList.contains('active')) {
        return;
      }

      // Deactivate old tab
      this.tabButtons.forEach(button => {
        button.classList.remove('active');
        button.setAttribute('aria-selected', 'false');
        button.setAttribute('tabindex', '-1');
      });
      this.tabPanes.forEach(pane => {
        pane.classList.remove('active');
        this.resetAnimations(pane);
      });

      // Activate new tab
      clickedButton.classList.add('active');
      clickedButton.setAttribute('aria-selected', 'true');
      clickedButton.setAttribute('tabindex', '0');

      targetPane.classList.add('active');
      this.triggerAnimations(targetPane);
      
      // Update container height to fit new content
      // Use a short delay to allow the DOM to update
      setTimeout(() => {
        this.updateContainerHeight();
      }, 50); // A small delay is safer
    }

    resetAnimations(pane) {
      const animatedElements = pane.querySelectorAll('.tab-pane__image-wrapper, .tab-pane__title, .tab-pane__text');
      animatedElements.forEach(el => {
        el.style.animation = 'none';
        el.style.opacity = '0';
      });
    }

    triggerAnimations(pane) {
      const image = pane.querySelector('.tab-pane__image-wrapper');
      const title = pane.querySelector('.tab-pane__title');
      const text = pane.querySelector('.tab-pane__text');

      if (image) {
        image.style.animation = '';
        image.style.opacity = '';
      }
      if (title) {
        title.style.animation = '';
        title.style.opacity = '';
      }
      if (text) {
        text.style.animation = '';
        text.style.opacity = '';
      }
    }
  }

  customElements.define('tabbed-content', TabbedContent);

  } catch(e) { console.error(e); }
})();
})();
